import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import editorUtils from '../utils/editor-utils';

function deleteCommandPlugin() {
	/**
	 * Plugin that encapsulates a custom "delete" command with custom delete behaviour.
	 *
	 * It was introduced to override some undesirable behaviour in webkit, where if the whole contents of macro placeholder (which is a single cell
	 * and single row table) were selected, running the native browser document.execCommand("Delete") will cause the
	 * whole table to be removed.
	 *
	 * It is intended that this custom delete command will delegate to the native command in other circumstances.
	 */
	return {
		init(ed) {
			ed.addCommand('mceDelete', (ui, value) => {
				/**
				 * Performs custom delete.
				 *
				 * @returns true if the custom delete was performed, false otherwise.
				 */
				function customDelete() {
					if (window.tinymce.Env.webkit) {
						const range = ed.selection.getRng(1);

						if (range.collapsed) {
							return false;
						}

						const macroPlaceholderBody = $(range.startContainer).closest(
							'.wysiwyg-macro-body',
							ed.getBody(),
						)[0];

						if (
							macroPlaceholderBody &&
							editorUtils.isRangeAtStartOf(macroPlaceholderBody, range) &&
							editorUtils.isRangeAtEndOf(macroPlaceholderBody, range)
						) {
							const plainText = $(macroPlaceholderBody.firstChild).is('pre');
							const nodeName = plainText ? 'pre' : 'p';
							const filler = $(`<${nodeName}><br data-mce-bogus='1'></${nodeName}>`)[0];

							$(macroPlaceholderBody).html(filler);
							ed.selection.select(filler, 1);

							return true;
						}
					}

					return false;
				}

				if (!customDelete()) {
					ed.getDoc().execCommand('Delete', ui, value);
				}
			});
		},

		getInfo() {
			return {
				longname: 'Delete Command Plugin',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
}

export default function () {
	window.tinymce.create('tinymce.plugins.DeleteCommandPlugin', deleteCommandPlugin());
	window.tinymce.PluginManager.add('deletecommand', window.tinymce.plugins.DeleteCommandPlugin);
}
